import axios, { baseUrl } from "./../axios/axios";
import axios1 from "axios";
import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { RootState } from "./index";
import { orderActions } from "./order-slice";
import { rfzoTherapyActions } from "./rfzoTherapy-slice";
import moment from "moment";
import { DeliveryPermitParams, DeliveryPermitResponse } from "../types/api";

export const fetchNewOrder = (
  orderId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(orderActions.fetchNewOrderStart());
    const URL = "/click_and_collect_order/" + orderId;
    axios
      .get(URL)
      .then((response) => {
        dispatch(orderActions.newOrderReceived(response.data));
        if (response.data.rfzoTherapyNumber !== null)
          dispatch(rfzoTherapyActions.rfzoTherapyOrderReceived(response.data));
      })
      .catch((error) => {
        console.error("Error fetching new order:", error);
        dispatch(orderActions.fetchNewOrderFailed());
      });
  };
};

export const uploadDeliveryConsent = (formData: any, userId: number) => {
  const URL =
    baseUrl +
    `/delivery_permit/${userId}?access_token=${localStorage.getItem("token")}`;

  return axios1
    .put(URL, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error uploading delivery consent:", error);
    });
};

export const fetchOrderForStatistics = (
  params: any,
  marketplaceIds?: {
    branchMarketplaceId: string | number;
    marketplaceId: string | number;
  }
) => {
  let statusArray = params.status.split(",");
  let statusString = "";

  if (params?.status === "ALL") {
    statusString = "";
  } else {
    if (statusArray.length === 1) {
      statusString = `status: '${params.status}' and`;
    } else {
      const substring = statusArray.map((a: any) => `'${a}'`);
      statusString = `status in (${substring.join(", ")}) and`;
    }
  }

  // Get marketplace IDs from parameters instead of localStorage
  let marketplaceId: string | number | null;
  let branchId: string | number | null;

  if (marketplaceIds) {
    marketplaceId = marketplaceIds.marketplaceId;
    branchId = marketplaceIds.branchMarketplaceId;
  } else {
    // Fallback to localStorage (but warn about potential race condition)
    marketplaceId = localStorage.getItem("marketplaceId");
    branchId = localStorage.getItem("branchMarketplaceId");
    console.warn(
      "order-actions: Reading localStorage for marketplace IDs - consider passing as parameters to avoid race conditions"
    );
  }

  // Guard against missing marketplace info
  if (!marketplaceId || !branchId) {
    console.warn(
      "order-actions: Cannot fetch statistics - marketplace IDs not available"
    );
    return Promise.reject("Marketplace IDs not available");
  }

  const URL_transactions = `click_and_collect_transaction/all?filter=${statusString} marketplace.id.marketplaceId:${marketplaceId} and marketplace.id.branchMarketplaceId:${branchId}`;
  return axios.get(URL_transactions, {
    params: {
      createdFrom: params.createdFrom,
      createdTo: params.createdTo,
      // "marketplace.id.marketplaceId": marketplaceId,
      // "marketplace.id.branchMarketplaceId": branchMarketplaceId
    },
  });
};
export const fetchPermitsForDriver = (
  userId?: number,
  driverId?: number,
  lbo?: string
) => {
  const URL = baseUrl + "/delivery_permit/" + userId + "/" + driverId;

  let params = {};

  if (lbo) {
    params = {
      LBO: lbo,
    };
  }
  return axios.get(URL, {
    params: params,
  });
};
export const fetchPermitsForStore = (
  cncOrderId: number,
  volunteerId: number
): Promise<{ data: DeliveryPermitResponse }> => {
  const URL = baseUrl + "/delivery_permit/volunteer";

  return axios
    .get(URL, {
      params: {
        cncOrderId,
        volunteerId,
      },
    })
    .catch((error) => {
      console.error("CNC permit API failed:", error);
      throw error;
    });
};

export const fetchOrders = (
  branchMarketplaceId: number,
  marketplaceId: number,
  shouldSendPos: boolean = true
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(orderActions.fetchOrdersStart());
    const URL =
      "/click_and_collect_order/" + branchMarketplaceId + "/" + marketplaceId;
    axios
      .get(URL)
      .then((response) => {
        dispatch(orderActions.orders(response.data));
      })
      .catch((error) => {
        console.log("Error se desio" + error);
        dispatch(orderActions.fetchOrdersFailed());
      });
  };
};

export const processOrderAction = (
  cncOrderId: number,
  note: string,
  willBeReady: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(orderActions.processOrderStart());
    const URL =
      "/click_and_collect_order/" +
      cncOrderId +
      "?willBeReadyIn=" +
      willBeReady +
      "&note=" +
      note;
    axios
      .put(URL)
      .then((response) => {
        dispatch(
          orderActions.processOrder({
            orderId: cncOrderId,
            noteForUser: note,
            responseData: response.data,
          })
        );
      })
      .catch((error) => {
        console.log("Error se desio" + error);
        dispatch(orderActions.processOrderFailed());
      });
  };
};
export const processOrderForDriverAction = (
  cncOrderId: number,
  userId?: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(orderActions.processOrderStart());
    const URL =
      "/click_and_collect_order/delivery_user/" + cncOrderId + "/" + userId;
    axios
      .put(URL)
      .then((response) => {
        dispatch(fetchAllOrdersForDriverUser());
      })
      .catch((error) => {
        console.log("Error se desio" + error);
        dispatch(orderActions.processOrderFailed());
      });
  };
};
export const finishOrderForDriverAction = (
  cncTransactionId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(orderActions.processOrderStart());
    const URL =
      "/click_and_collect_transaction/delivery_taken/" + cncTransactionId;
    axios
      .put(URL, {
        status: "TAKEN",
      })
      .then((response) => {
        dispatch(fetchAllOrdersForDriverUser());
      })
      .catch((error) => {
        console.log("Error se desio" + error);
        dispatch(orderActions.processOrderFailed());
      });
  };
};

export const preparedOrderAction = (
  cncOrderId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(orderActions.preparedOrderStart());
    const URL = "/click_and_collect_order/prepared/" + cncOrderId;
    axios
      .put(URL)
      .then((response) => {
        console.log(response.data);
        // todo ovde treba da se promeni status
        dispatch(orderActions.preparedOrder(cncOrderId));
      })
      .catch((error) => {
        console.log("Error se desio" + error);
        dispatch(orderActions.preparedOrderFailed());
      });
  };
};

export const finishOrderAction = (
  cncOrderId: number,
  status: string,
  note: string,
  orderVerificationCode?: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(orderActions.finishOrderStart());
    const URL = "/click_and_collect_transaction";

    const requestBody = {
      cncOrderId: cncOrderId,
      status: status,
      note: note || undefined,
      orderVerificationCode: orderVerificationCode,
    };

    axios
      .post(URL, requestBody)
      .then((response) => {
        console.log(response.data);
        // dispatch(orderActions.finishOrder({cncOrderId: cncOrderId, status: status}));
        status !== "REJECTED"
          ? dispatch(
              orderActions.finishOrder({
                cncOrderId: cncOrderId,
                status: status,
                note: note,
              })
            )
          : dispatch(
              orderActions.rejectOrder({ cncOrderId: cncOrderId, note: note })
            );
      })
      .catch((error) => {
        console.log(error);
        dispatch(orderActions.finishOrderFailed());
      });
  };
};

export const fetchTransactions = (
  branchMarketplaceId: number,
  marketplaceId: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(orderActions.fetchTransactionsStart());
    const URL =
      "/click_and_collect_transaction/" +
      marketplaceId +
      "/" +
      branchMarketplaceId;
    axios
      .get(URL)
      .then((response) => {
        // console.log(response.data);
        dispatch(orderActions.transactions(response.data));
      })
      .catch((error) => {
        console.log("Error se desio" + error);
        dispatch(orderActions.fetchTransactionsFailed());
      });
  };
};

export const fetchAllOrdersForAdminUser = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(orderActions.fetchOrdersStart());
    const URL = "/click_and_collect_order";
    axios
      .get(URL)
      .then((response) => {
        console.log(response.data);
        dispatch(orderActions.orders(response.data));
      })
      .catch((error) => {
        console.log("Error se desio" + error);
        dispatch(orderActions.fetchOrdersFailed());
      });
  };
};

export const fetchAllOrdersForDriverUser = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  const userId = localStorage.getItem("id");
  return async (dispatch) => {
    dispatch(orderActions.fetchOrdersStart());
    const URL_orders =
      "/click_and_collect_order?filter=userAddress is not null";
    const URL_transactions =
      "/click_and_collect_transaction/all?filter=userDelivery.id:" + userId;
    // const URL_finishedOrdersForDriver = "/click_and_collect_transaction/all?filter=status:'TAKEN' and userDelivery.id:"+ userId;
    const ordersPromise = axios.get(URL_orders);
    const transactionsPromise = axios.get(URL_transactions);
    // const urlFinishedPromise = axios.get(URL_finishedOrdersForDriver)
    Promise.all([ordersPromise, transactionsPromise])
      .then(([ordersRes, transactionsRes]: any) => {
        const remapData = transactionsRes?.data.map((transaction: any) => ({
          ...transaction,
          id: transaction.orderNumber,
          transactionId: transaction.id,
        }));
        // const remapData2 = finishedRes?.data.map((transaction:any) => ({
        //     ...transaction,
        //     id: transaction.orderNumber,
        //     transactionId: transaction.id
        // }))
        let combinedOrdersArray = [...ordersRes.data, ...remapData];
        combinedOrdersArray.sort((a, b) => a.id - b.id);
        dispatch(orderActions.driverOrders(combinedOrdersArray));
      })
      .catch((error) => {
        console.log("Error se desio" + error);
        dispatch(orderActions.fetchOrdersFailed());
      });
  };
};

export const fetchAllTransactionsForAdminUser = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  const threeDaysAgo = moment()
    .subtract(7, "days")
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm");
  const momentNow = moment().format("YYYY-MM-DDTHH:mm");
  return async (dispatch) => {
    dispatch(orderActions.fetchTransactionsStart());
    const URL = `/click_and_collect_transaction/all?createdFrom=${threeDaysAgo}&createdTo=${momentNow}`;
    axios
      .get(URL)
      .then((response) => {
        dispatch(orderActions.transactions(response.data));
      })
      .catch((error) => {
        console.log("Error se desio" + error);
        dispatch(orderActions.fetchTransactionsFailed());
      });
  };
};

export const dismissSuspendedOrder = (
  transactionId: number
): ThunkAction<Promise<boolean>, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(orderActions.dismissSuspendedOrderStart());

    const URL = `/click_and_collect_transaction/suspended_info_shown/${transactionId}`;

    try {
      await axios.put(URL);
      dispatch(orderActions.dismissSuspendedOrderSuccess(transactionId));
      return true;
    } catch (error) {
      console.error("Error dismissing suspended order notification:", error);
      dispatch(orderActions.dismissSuspendedOrderFailed());
      return false;
    }
  };
};

export const dismissAllSuspendedOrders = (
  transactionIds: number[]
): ThunkAction<Promise<void>, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    for (const transactionId of transactionIds) {
      await dispatch<any>(dismissSuspendedOrder(transactionId));
    }
  };
};
